module.exports = __webpack_public_path__ + "img/67.98088428.jpg";